<template>
    <div class="limit-content">
        <div  style="text-align:center;margin-bottom:40px;" >
            <span class="txt-title">开通会员解锁更多维度信息</span> 
        </div>
        <div style="background-color: #fff;">
            <div class="sku-price-container ">
                <div v-for="(item,index) in vipPriceList" :key="item.id" class="sku-price-item " :class="{'sku-price-active':item.id==selVipId}" @click='onChangeVipFun(item.id)'>
                    <span v-if="index==0" class="sku-tag-info">推荐</span>
                    <p class="sku-year-info">{{item.name}}</p>
                    <p class="sku-price-info"><span class="sku-unit">¥</span><span class="sku-price">{{item.price}}</span></p>
                    <span class="mb8 sku-desc-info">每天仅<em>{{item.priceOfDay}}</em>元</span>
                </div>
            </div>
            
            <div class="pay-order" v-if='isShowPayInfo'>
                <div class="pay-info">
                    <div class="pline">
                        <div>到期日期：</div>
                        <div>{{vipPriceList.find(t=>t.id==selVipId)?.deadline}}</div>
                    </div>
                    <div class="pline">
                        <div>实付金额：</div>
                        <div>
                            <span class="color-hl">
                                <span style="font-size: 14px;">￥</span>
                                {{vipPriceList.find(t=>t.id==selVipId)?.price}}
                            </span>
                        </div>
                    </div>
                    <div class="pay-desc">
                        <p>1、完成支付后可在个人中心查看支付订单</p>
                        <p>2、可扫页面底部二维码添加客服开发票</p>
                        <p>3、会员自支付完成之时起5分钟内生效</p>
                    </div>
                </div>
                <div class="pay-qrcode">
                    <div class="pay-box">
                        <qrcode-vue :value="payUrl" :size="118" level="H"/>
                    </div>
                    <div class="pay-line">使用 <i class="iconfont ec-icon-wx-pay" style="font-size:14px;color:#1AAD19;"></i> 扫码支付</div>
                </div>
            </div>
            <div v-else style="text-align:center;padding-bottom:20px;">
                <el-button type="primary" style="width:30%;font-size:18px;" @click="onPayFun">立 即 开 通</el-button>
            </div>
        </div>
        <div class='example' v-if='$props.url'>
            <el-image style="width: 100%; " :src="`https://data.chinaecono.com/images/${$props.url}`" fit="contain" />
        </div>
        <el-dialog v-model="dialogWXVisible" append-to-body :close-on-click-modal='false' title="添加微信" :width="400" @close="onCloseDialogFun">
            <div class="LSb1iW3M">
                <div style="color: rgba(30, 32, 35, .45);text-align:center;">
                    感谢您选择我们的产品,请添加微信，我们将为您提供即时的售后支持和专业的技术支持。
                </div>
                <div class="JBWR88_b">
                    <el-image style="width:186px; height:186px" src="https://data.chinaecono.com/images/wx_code.jpg" fit="fill" />
                    <div>微信扫码</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {getVIPPriceList,createPayOrder,getVipOrder,addUserLog} from '@/http/basicsApi'
import {parseTime} from '@/utils/index'
import {ref } from '@vue/reactivity';
import QrcodeVue from 'qrcode.vue';
import { onUnmounted } from 'vue';
import router from '@/router/index.js'
import store from '@/store';
import { ElMessage  } from 'element-plus'
export default {
    props:{
         url:{
            type:String,
            default:''
         }
    },
    components:{
        QrcodeVue
    },
    setup() {
        let isShowPayInfo=ref(false);//是否显示支付信息
        let vipPriceList=ref([]);//vip的价格列表
        let selVipId=ref(0);//选中vipId
        //调用微信natvie支付接口，获取二维码url
        const getVIPPriceListFun= async()=>{
            let res=await getVIPPriceList();
            console.log(res);
            if(res.code==20000){
                vipPriceList.value=res.data;
                
                vipPriceList.value.forEach(t=>{
                    t.priceOfDay=Math.round(t.price/t.dayCount * 100) / 100 ;
                    let date=new Date();
                    t.deadline=parseTime(date.setDate(date.getDate() + t.dayCount),'{y}-{m}-{d}')
                })
                selVipId.value=vipPriceList.value[0].id;
            }
        }
        //选择套餐
        const onChangeVipFun=(id)=>{
            selVipId.value=id;
            isShowPayInfo.value=false;
            if(timer){
                clearInterval(timer);
                timer=null;
            }
        }
        //支付
        let payUrl=ref('');//支付二维码的url
        let timer=null;
        let isPay=ref(false);//是否支付
        const onPayFun=async()=>{
            //调用Native下单API生成预支付交易以获取支付二维码链接code_url
            let res=await createPayOrder(selVipId.value);
            console.log(res);
            if(res.code==20000){
                //打开支付对话框，用户扫描支付二维码
                payUrl.value=res.data.codeUrl;
                let orderCode=res.data.orderCode;
                isShowPayInfo.value=true;
                //循环请求查看是否支付成功
                timer = setInterval(() => {
                    getVipOrderFun(orderCode);
                }, 1000);
            }
            //记录用户操作日志
            addUserLog(router.currentRoute.value.name,router.currentRoute.value.fullPath,'支付',`{"selVipId":${selVipId.value}}`);
               
        }
        //查询订单信息
        let dialogWXVisible=ref(false);
        const getVipOrderFun= async(orderCode)=>{
            let params={
                orderCode:orderCode,
                pageSize:1,
                pageIndex:1
            }
            let res=await getVipOrder(params);
            if(res.code==20000 && res.data.totalCount>0){
                isPay.value=res.data.dataList[0].state==20?true:false;
                if(isPay.value){//停止循环
                    clearInterval(timer);
                    timer=null;
                    ElMessage.success({
                        message: '支付成功', 
                    }); 
                    //执行父组件的关闭对话框

                    //store.commit("setIsRightVisable", [false,'']);
                    // //跳转到首页
                    // router.push('/home');
                    dialogWXVisible.value=true;
                }
            }
        }
        //对话框关闭
        const onCloseDialogFun=()=>{
            //执行父组件的关闭对话框
            store.commit("setIsRightVisable", [false,'']);
            //跳转到首页
            router.push('/home');
        }
        onUnmounted(()=>{
            
            //停止循环
            if(timer){
                clearInterval(timer);
                timer=null;
            }
        })
        //加载
        getVIPPriceListFun();
        
        return{
            vipPriceList,
            selVipId,
            isShowPayInfo,
            onChangeVipFun,
            onPayFun,
            dialogWXVisible,
            payUrl,
            isPay,
            onCloseDialogFun,
        }
    },
}
</script>
<style lang='scss' scoped>
@import '@/styles/variables.scss';

.pay-order{
    display: flex;
    justify-content: space-between;
    padding:12px 20px;
}
.pay-info{
    flex: 1;
    margin-right: 100px;
    font-size: 14px;
    .pline {
        line-height: 22px;
        margin-bottom: 5px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
    }
    .color-hl {
        color: #ff7d18;
        font-family: D-DIN-Bold;
        font-size: 20px;
        position: relative;
        top: -1px;
        font-weight: bold;
    }
}
.pay-desc {
    margin-top: 10px;
    font-size: 12px;
    text-align: left;
    color: #999;
    p{
        margin: 3px;
    }
}
.pay-qrcode{
    width: 130px;
    background: #fff;
    position: relative;
}
 .pay-box {
    width: 130px;
    height: 130px;
    padding: 6px;
    display: inline-block;
    position: relative;
    border:1px solid #e6e6e6
}
.pay-line {
    text-align: center;
    font-size: 12px;
    background-color: #e6e6e6;
    line-height: 20px;
}
.example{
    position: relative;
    padding: 10px 5px;
    &::before {
        content: "";
        position: absolute;
        top: 0px;
        left: -3px;
        width: 69px;
        height: 27px;
        z-index: 2;
        background: url(data:image/png;base64,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) 0% 0% / 100% 100% no-repeat;
    }
}
</style>